import type { ISnippet } from 'src/services/api';

const getSnippetSearchTokens = (snippets: ISnippet[] | undefined) => {
    if (!snippets) {
        return [];
    }

    return snippets.reduce<[ISnippet, string[]][]>((acc, snippet) => {
        const name = snippet.name || '';
        const content = snippet.contents || '';

        const tokens = [
            name,
            content,
        ].filter(Boolean).map((token) => token.toLowerCase());

        acc.push([snippet, tokens]);
        return acc;
    }, []);
};

export const searchSnippets = (
    snippets: ISnippet[] | undefined,
    searchQuery: string,
) => {
    if (!snippets) {
        return [];
    }

    if (!searchQuery) {
        return snippets;
    }

    const snippetSearchTokens = getSnippetSearchTokens(snippets);

    const filteredSnippets: ISnippet[] = [];

    const searchQueryTokens = searchQuery
        .toLowerCase()
        .split(' ')
        .map((token) => token.trim())
        .filter(Boolean);

    for (const [snippet, snippetTokens] of snippetSearchTokens) {
        let foundAllSearchTokens = true;

        for (const searchToken of searchQueryTokens) {
            let foundSearchToken = false;

            for (const snippetToken of snippetTokens) {
                if (snippetToken.includes(searchToken)) {
                    foundSearchToken = true;
                    break;
                }
            }

            if (!foundSearchToken) {
                foundAllSearchTokens = false;
                break;
            }
        }

        if (foundAllSearchTokens) {
            filteredSnippets.push(snippet);
        }
    }
    return filteredSnippets;
};